import { Component, OnInit } from '@angular/core';
import { combineLatest, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AttemptedPathService } from '@app/core/attempted-path.service';
import { DocumentSignerGraphQLService } from '@app/core/document-signer-graphql.service';
import { DocumentSigner } from '@app/core/legal-documents';
import { MODULE_LEGAL_DOCUMENT_PAGE } from '@app/core/mixpanel.constants';
import { CurrentUserIdGraphQLService } from '@app/core/tos/current-user-id-graphql.service';
import { RegistrationAnalyticsService } from '@app/registration';
import { GraphNavigationService } from '@app/registration/graph/graph-navigation.service';
import { BeneficiaryForLegalDoc } from '@app/shared';

@Component({
  selector: 'om-tos',
  templateUrl: './tos-interstitial.component.html',
})
export class TosInterstitialComponent implements OnInit {
  documentSignerAndBeneficiary$: Observable<[DocumentSigner, BeneficiaryForLegalDoc]>;

  protected percentComplete: number | null = null;

  constructor(
    private attemptedPathService: AttemptedPathService,
    private documentSignerGraphQLService: DocumentSignerGraphQLService,
    private currentUserIdGraphQLService: CurrentUserIdGraphQLService,
    private graphNavigationService: GraphNavigationService,
    private registrationAnalyticsService: RegistrationAnalyticsService,
  ) {}

  ngOnInit() {
    const documentSigner$ = this.documentSignerGraphQLService
      .fetch()
      .pipe(map(result => result.data.patient.documentSigner));
    const beneficiary$ = this.currentUserIdGraphQLService
      .fetch()
      .pipe(map(result => ({ id: +result.data.patient.id })));

    this.documentSignerAndBeneficiary$ = combineLatest([documentSigner$, beneficiary$]);

    if (this.graphNavigationService.navigationInProgress) {
      this.percentComplete = this.graphNavigationService.percentComplete;
      this.registrationAnalyticsService.graphNavigationPageViewed({
        module: MODULE_LEGAL_DOCUMENT_PAGE,
        ...this.graphNavigationService.analyticsProperties,
      });
    }
  }

  continue() {
    if (this.graphNavigationService.navigationInProgress) {
      this.graphNavigationService.navigate();
    } else {
      this.attemptedPathService.navigateToAttemptedPath();
    }
  }
}
